export class DateUtility {
    /**
     * Data una stringa espressa nel formato DD/MM/YYYY ne ritorna
     * la data equivalente
     * @param dataIta 
     */
    static parseDateFromItalianFormat(dataIta: string): Date {
        const dateParts = dataIta.split('/');
        const day = Number(dateParts[0]);
        if (day < 0 || day > 31) {
            throw new Error('Error while extracting day from the date String');
        }
        const month = Number(dateParts[1]);
        if (month < 0 || month > 12) {
            throw new Error('Error while extracting month from the date String');
        }
        const year = Number(dateParts[2]);
        if (year < 1 || year > 2100) {
            throw new Error('Error while extracting year from the date String');
        }
        return new Date(Date.UTC(year, month, day, 0, 0, 0));
    }

    /**
     * Data una data ne produce la rappresentazione nel formato
     * YYYY-MM-GG
     * @param date 
     */
    static generateIsoShortDateString(date: Date): string {
        const monthNumber = date.getMonth() + 1;
        const monthString = String(monthNumber).padStart(2, '0');
        const dayNumber = date.getDate();
        const dayString = String(dayNumber).padStart(2, '0');
        const formattedDate: string = `${date.getFullYear()}-${monthString}-${dayString}`;
        return formattedDate;
    }

    /**
     * Restituisce la data in formato gg/mm/aaa
     * @param date
     */
    static generateItalianDateString(date: Date): string {
        const monthNumber = date.getMonth() + 1;
        const monthString = String(monthNumber).padStart(2, '0');
        const dayNumber = date.getDate();
        const dayString = String(dayNumber).padStart(2, '0');
        const formattedDate: string = `${dayString}/${monthString}/${date.getFullYear()}`;
        return formattedDate;
    }

    static getGiorniDifferenzaTraDueDate(d1: Date, d2: Date): number {
        const oneDay = 24 * 60 * 60 * 1000;
        const diffDays = Math.round(Math.abs((d1.getTime() - d2.getTime()) / (oneDay)));
        return diffDays;
    }

}
